import React, {useEffect, useState} from 'react';
import DashboardContainer from '../sideBar/DashboardContainer';
import {useNavigate} from 'react-router-dom';
import {newTestCheckPakAction, newTestGetStoredSMILESAction} from '../../redux/toolkit/newTestSlice';
import {useDispatch, useSelector} from 'react-redux';
import { logoutAction } from '../../redux/toolkit/loginSlice';
import PageLayout, {Card, CardHeader, CardBody, PREDICT_STEPS} from '../layout/PageLayout';
import c from './newTest.module.css';
import Modal from './Modal';

const NewTestContainer = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const {statusCodeGetPak, checkPakResult, smilesResult} = useSelector(state => state?.newTestCheckPakReducer);

    const plReqIdLS = localStorage.getItem('platform_request_id');
    
    const [message, setMessage] = useState('');
    const [myArraySmiles, setMyArraySmiles] = useState([]);
    const [platformRequestId, setPlatformRequestId] = useState(plReqIdLS);
    const [textareaValue, setTextareaValue] = useState('');
    const [showModal, setShowModal] = useState(false);
  
    const { status_code } = checkPakResult;

    const compoundCount = textareaValue.split('\n').filter(l => l.trim()).length;

    useEffect(() => {
      // A New Test opened without an eLab platform_request is a direct/manual
      // session — clear any stale eLab marker so the "Upload reports to eLabNext"
      // checkbox on the result page won't show for non-eLab predictions.
      if (!localStorage.getItem('platform_request_id')) {
        localStorage.removeItem('platform_id');
      }
    }, []);

    useEffect(() => {
      if (status_code === 401) {
        dispatch(logoutAction());
        navigate("/");
        window.location.reload();
      }
    }, [dispatch, status_code, navigate]);

    useEffect(()=>{
        if(checkPakResult?.status_code === 401){
            localStorage.removeItem('access_token_toxometris');
            window.location.href = '/';
        }
    },[checkPakResult?.status_code])

    useEffect(() => {
        if (platformRequestId) {
            dispatch(newTestCheckPakAction({
                'platform_request_id': platformRequestId
            }));
        }
    }, [dispatch, platformRequestId]);

    useEffect(() => {
        if (checkPakResult?.status_code === 200 && platformRequestId && checkPakResult.response) {
            window.location.href = checkPakResult.response;
        } else if (platformRequestId && checkPakResult?.status_code === 200 && !checkPakResult.response) {
            dispatch(newTestGetStoredSMILESAction({
                'platform_request_id': platformRequestId
            }))
        }
    }, [checkPakResult.response, checkPakResult?.status_code, platformRequestId, dispatch])

    useEffect(() => {
        if (platformRequestId && statusCodeGetPak === 200) {
            dispatch(newTestGetStoredSMILESAction({
                'platform_request_id': platformRequestId
            }))
        }
    }, [dispatch, platformRequestId, statusCodeGetPak])

    useEffect(() => {
        if (smilesResult.compounds?.length > 0) {
            setMyArraySmiles(smilesResult.compounds)
            setTextareaValue(smilesResult.compounds?.join('\n'));
        } else {
            setMyArraySmiles([])
            setTextareaValue('');
        }
    }, [smilesResult]);

    // Show modal when the specific API error occurs
    useEffect(() => {
        
        if (smilesResult?.status === 'error' && 
            smilesResult?.status_code === 400 && 
            smilesResult?.message === 'elab_api_null_response') {
            setShowModal(true);
        }
    }, [smilesResult]);

    const handleTextareaChange = (event) => {
        if (message) {
            setMessage('');
        }
        if (platformRequestId) {
            setPlatformRequestId(null);
        }
        setTextareaValue(event.target.value);
        setMyArraySmiles(event.target.value.split('\n'));
    };

    const handleSubmit = () => {
        setPlatformRequestId(null);
        if (myArraySmiles?.length > 0 && !message && textareaValue) {
            navigate('/checkValidate', {state: myArraySmiles});
        } else setMessage('Please fill the list');
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    return (
        <DashboardContainer>
            <PageLayout title='New Test'
                        subtitle='Paste one SMILES or InChI per line. They are validated before any prediction runs.'
                        steps={PREDICT_STEPS} currentStep={0} narrow>
                <Card padded={false}>
                    <CardHeader title='Compounds'
                                actions={<span className={c.compoundCount}>{compoundCount} compound{compoundCount === 1 ? '' : 's'}</span>}/>
                    <CardBody>
                        <textarea placeholder={'CCO\nc1ccccc1\nCC(=O)Oc1ccccc1C(=O)O'}
                                  value={textareaValue}
                                  onChange={handleTextareaChange}
                                  rows='10' className={c.newTestTextarea}
                        />
                        {message && <p className={c.newTestError}>{message}</p>}
                        <div className={c.newTestButton}>
                            <button onClick={handleSubmit}>Next</button>
                        </div>
                    </CardBody>
                </Card>
            </PageLayout>

            <Modal isOpen={showModal} onClose={handleCloseModal}>
                <h4>Missing Chemical Structure Information</h4>
                <div className={c.modalTextContent}>
                    <p>The sample(s) you have selected do not contain information about their chemical structure. Each sample must have a defined chemical formula in one of the following formats — SMILES or InChI — in order to enable prediction.</p>
                    <br/>
                    <p>If you want to make a test prediction, please add an arbitrary SMILES formula in textbox such as <b>C1=CC=CC=C1</b> and click Next.</p>
                    <br/><br/>
                    <p style={{fontSize: '12px'}}>Please note that SMILES and InChI fields are not enabled by default in the SciSure / eLabNext environment. To enable them, follow these steps:</p>
                    
                    <ol style={{fontSize: '12px'}}>
                        <li style={{fontSize: '12px'}}>Go to Configuration → Sample Types.</li>
                        <li style={{fontSize: '12px'}}>Click the Add Sample Type button and select Chemical as the sample type.</li>
                        <li style={{fontSize: '12px'}}>After adding the chemical type, click the Edit button, then select Add New Field.</li>
                        <li style={{fontSize: '12px'}}>In the Field Name textbox, enter SMILES or InChI, and click Save.</li>
                    </ol>
                    
                    <p style={{fontSize: '12px'}}>Once completed, you will be able to add chemical structure information to your compounds. For more information please contact <a href="mailto:support@toxometris.ai">support@toxometris.ai</a></p>
                </div>
            </Modal>
        </DashboardContainer>
    );
};

export default NewTestContainer;